import { useEffect, useRef, useState } from 'react';

export function useWebDragScroll({
  listRef,
  scrollX,
  itemWidth,
  dataLength,
}: {
  listRef: React.RefObject<any>;
  scrollX: { value: number };
  itemWidth: number;
  dataLength: number;
}) {
  const [dragging, setDragging] = useState(false);
  const startX = useRef(0);
  const startScrollX = useRef(0);

  const minScrollX = itemWidth;
  const maxScrollX = dataLength * itemWidth;

  const handleMouseDown = (e: React.MouseEvent) => {
    setDragging(true);
    startX.current = e.clientX;
    startScrollX.current = scrollX.value;
    document.body.style.cursor = 'grabbing';
  };

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!dragging || e.buttons === 0) return;
      const delta = startX.current - e.clientX;
      let nextX = startScrollX.current + delta;
      nextX = Math.max(minScrollX, Math.min(maxScrollX, nextX));
      listRef.current?.scrollToOffset({ offset: nextX, animated: false });
    };

    const handleMouseUp = () => {
      setDragging(false);
      document.body.style.cursor = 'default';
    };

    if (dragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      window.addEventListener('mouseleave', handleMouseUp);

      return () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
        window.removeEventListener('mouseleave', handleMouseUp);
      };
    }
  }, [listRef, dragging, minScrollX, maxScrollX]);

  return {
    dragging,
    handleMouseDown: handleMouseDown,
  };
}
